import { Component } from 'react';
import { Errors} from 'forms/rrf';
import { FormGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import LayoutContainer from '../../../layout/layout-container/index';
import RequiredInput from '../elements/required-input';
import SearchableSelect from '../elements/searchable-select';

class SecurityQuestionAnswerInput extends Component {
  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      selected: { value: '', label: 'Select a question...'}
    };
  }

  render() {
    const {
      questionModel, questionLabel, questionControlId,
      answerModel, answerLabel, answerPlaceHolder, answerControlId, questions
    } = this.props;

    const questionOptions = questions.map(question => (
      {
        value: question.id,
        label: question.attributes.name
      }
    ));

    const handleChange = (value) => {
      this.setState({
        selected: value
      });
    };

    return (
      <LayoutContainer>
        <FormGroup controlId={questionControlId} className={`form-group${this.state.security_question ? ` has-${this.state.security_question}` : ''}`}>
          <SearchableSelect
            label={questionLabel}
            model={questionModel}
            options={questionOptions}
            value={this.state.selected}
            onChange={value => handleChange(value)}
          />
          <Errors
            className="errors"
            messages={{required: 'This field is required'}}
            model={questionModel}
            show={{
              touched: true,
              focus: false
            }}
          />
        </FormGroup>

        <RequiredInput
          controlId={answerControlId}
          label={answerLabel}
          model={answerModel}
          placeholder={answerPlaceHolder}
        />

      </LayoutContainer>
    );
  }
}

SecurityQuestionAnswerInput.propTypes = {
  questions: PropTypes.array.isRequired,
  questionModel: PropTypes.string.isRequired,
  questionControlId: PropTypes.string,
  questionLabel: PropTypes.string,
  answerModel: PropTypes.string.isRequired,
  answerControlId: PropTypes.string,
  answerLabel: PropTypes.string,
  answerPlaceHolder: PropTypes.string,
};

SecurityQuestionAnswerInput.defaultProps = {
  questionControlId: 'securityQuestion',
  questionLabel: 'Security question 1',
  answerControlId: 'securityAnswer',
  answerLabel: 'Security answer 1',
  answerPlaceHolder: 'Security answer 1'
};

export default SecurityQuestionAnswerInput;
